import { openBlock, createElementBlock, createElementVNode, defineComponent, ref, reactive, computed, watch, onMounted, createBlock, unref, withCtx, withDirectives, normalizeClass, createCommentVNode, renderSlot, resolveDynamicComponent, createTextVNode, toDisplayString, createVNode, vShow } from 'vue';
import UiTransition from '@omnica/transition-vue3';
import { componentExists } from '@omnica/base-vue3';
import { TYPE } from '@omnica/alert';

const _hoisted_1$1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1 = /*#__PURE__*/createElementVNode("path", {
  d: "M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3 = [
  _hoisted_2$1
];

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1, _hoisted_3))
}

const _hoisted_1 = {
    key: 0,
    class: "omnica-alert__icon-outline"
};
const _hoisted_2 = { class: "omnica-alert__icon" };
var script = /*#__PURE__*/ defineComponent({
    __name: 'UiAlert',
    props: {
        /** Тип предупреждения */
        type: {
            type: String,
            default: TYPE.PRIMARY,
            validator: type => Object.values(TYPE).includes(type),
        },
        /** Название иконки для соответствующего типа предупреждения */
        icon: {
            type: null,
            validator: (icon) => typeof icon === 'string' || icon === null,
            default: null,
        },
        /** Заголовок с предупреждением */
        text: {
            type: String,
            default: '',
        },
        /** Наличие предупреждения или его отсутствие на странице */
        shown: {
            type: Boolean,
            default: true,
        },
        /** Добавляет иконку закрытия к контенту подсказки и возможность закрыть её вручную */
        closable: {
            type: Boolean,
            default: true,
        },
        /** Определяет, будет ли текст ошибок обрезаться через многоточие или переноситься на следующую строку */
        ellipsis: {
            type: Boolean,
            default: false,
        },
        /** Уменьшает размер текста */
        small: {
            type: Boolean,
            default: false,
        },
        /** Прокрутка родителя к боксу при его появлении, полезно при показе ошибок */
        scrollToAlert: {
            type: Boolean,
            default: false,
        },
        /** Устанавливает анимацию прокрутки до определённого элемента */
        scrollBehavior: {
            type: String,
            default: 'smooth',
        },
    },
    setup(__props, { expose }) {
        const props = __props;
        const root = ref(null);
        const state = reactive({
            shown: props.shown,
        });
        const iconComputed = computed(() => {
            var _a, _b;
            return (_b = (_a = props.icon) !== null && _a !== void 0 ? _a : {
                [TYPE.DANGER]: 'clear-circle-outlined',
                [TYPE.PRIMARY]: 'info-outlined',
                [TYPE.WARNING]: 'error-outlined',
                [TYPE.SUCCESS]: 'checkmark-circle-outlined',
            }[props.type]) !== null && _b !== void 0 ? _b : null;
        });
        const scrollIntoView = () => {
            var _a;
            (_a = root.value) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: props.scrollBehavior });
        };
        expose({
            scrollIntoView,
        });
        watch(() => props.shown, (value) => {
            state.shown = value;
            if (state.shown) {
                scrollIntoView();
            }
        });
        onMounted(() => {
            if (props.scrollToAlert) {
                scrollIntoView();
            }
        });
        return (_ctx, _cache) => {
            return (openBlock(), createBlock(unref(UiTransition), { name: "fade" }, {
                default: withCtx(() => [
                    withDirectives(createElementVNode("div", {
                        ref_key: "root",
                        ref: root,
                        class: normalizeClass({
                            'omnica-alert': true,
                            'omnica-alert_success': __props.type === unref(TYPE).SUCCESS,
                            'omnica-alert_notice': __props.type === unref(TYPE).WARNING,
                            'omnica-alert_error': __props.type === unref(TYPE).DANGER,
                            'omnica-alert_small': __props.small,
                        })
                    }, [
                        createCommentVNode(" @slot Иконка слева "),
                        renderSlot(_ctx.$slots, "icon", {}, () => [
                            (unref(iconComputed))
                                ? (openBlock(), createElementBlock("div", _hoisted_1, [
                                    createElementVNode("div", _hoisted_2, [
                                        (unref(componentExists)('UiIcon'))
                                            ? (openBlock(), createBlock(resolveDynamicComponent('UiIcon'), {
                                                key: 0,
                                                name: unref(iconComputed)
                                            }, null, 8 /* PROPS */, ["name"]))
                                            : createCommentVNode("v-if", true)
                                    ])
                                ]))
                                : createCommentVNode("v-if", true)
                        ]),
                        createElementVNode("div", {
                            class: normalizeClass({
                                'omnica-alert__title': true,
                                'omnica-alert__title_ellipsis': __props.ellipsis,
                            })
                        }, [
                            createCommentVNode(" @slot Заголовок c предупреждением "),
                            renderSlot(_ctx.$slots, "default", {}, () => [
                                createTextVNode(toDisplayString(__props.text), 1 /* TEXT */)
                            ])
                        ], 2 /* CLASS */),
                        (__props.closable)
                            ? (openBlock(), createElementBlock("div", {
                                key: 0,
                                class: "omnica-alert__close",
                                onClick: _cache[0] || (_cache[0] = ($event) => (state.shown = false))
                            }, [
                                createVNode(unref(render), { class: "omnica-alert__close-icon" })
                            ]))
                            : createCommentVNode("v-if", true)
                    ], 2 /* CLASS */), [
                        [vShow, state.shown]
                    ])
                ]),
                _: 3 /* FORWARDED */
            }));
        };
    }
});

script.__file = "packages/alert/src/UiAlert.vue";

export { script as default };
